<div class="d-flex flex-column position-relative subscription">
    <button
        mat-icon-button
        mat-dialog-close
        aria-label="Close AWB subscribtion"
        class="position-absolute end-0 top-0 p-0 aling-center"
    >
        <mat-icon>close</mat-icon>
    </button>
    @if (!loading) {
        <div class="d-flex align-items-center justify-content-center mt-4 flex-column">
            <app-facility-logo class="mt-3" [width]="'140'" [height]="'102'" />
            <h4 class="mat-headline-4 mb-4">Autopay cancellation</h4>
            <div class="mat-subtitle-1 text-center">
                If you cancel AutoPay, the payment will be stopped, but you will still receive an email notification
                when the shipment is arrived by AGI.
            </div>
            <div>
                <h2 class="mat-headline-6 mb-3 awb" color="primary">AWB: {{ awb }}</h2>
                <div>
                    <div class="mt-5 d-flex justify-content-center">
                        <button
                            matButton="outlined"
                            appMatStrokedButtonBorder
                            mat-dialog-close
                            color="primary"
                            class="me-2"
                        >
                            NEW SEARCH
                        </button>
                        <button matButton="filled" type="submit" color="primary" (click)="cancel()">
                            CANCEL AUTOPAY
                        </button>
                    </div>
                </div>
            </div>
        </div>
    } @else {
        <div class="py-2 d-flex flex-grow-1 justify-content-center align-items-center loading">
            <mat-spinner diameter="36" />
        </div>
    }
</div>
